import { render, staticRenderFns } from "./UjJelszoModal.vue?vue&type=template&id=63296f7c&"
import script from "./UjJelszoModal.vue?vue&type=script&lang=js&"
export * from "./UjJelszoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports